import { MotionStyle } from "framer-motion"

/** @public */
export interface BlendingProperties {
    blendingMode: BlendingMode
}

/** @public */
export type BlendingMode =
    | "normal"
    | "multiply"
    | "screen"
    | "overlay"
    | "darken"
    | "lighten"
    | "color-dodge"
    | "color-burn"
    | "hard-light"
    | "soft-light"
    | "difference"
    | "exclusion"
    | "hue"
    | "saturation"
    | "color"
    | "luminosity"

/** @internal */
export function collectBlendingFromProps(node: Partial<BlendingProperties>, style: MotionStyle) {
    if (!node.blendingMode || node.blendingMode === "normal") return
    style.mixBlendMode = node.blendingMode
}
